import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ContentAccessTypeItem } from 'src/types/ContentAccessTypeItem';

import { getAccessTypeStringContent } from 'src/utils/getAccessTypeString';

import BookSvg from 'public/icons/Book.svg';
import MarkerSvg from 'public/icons/Marker.svg';
import PeopleSvg from 'public/icons/People.svg';
import PersonTickSvg from 'public/icons/PersonTick.svg';
import PriceTagSvg from 'public/icons/PriceTag.svg';
import TimerSvg from 'public/icons/Timer.svg';

import ctaStyles from '../../CourseDetailCallToAction.module.css';

type contentDetailsHeaderProps = {
	AccessType: Array<ContentAccessTypeItem>;
	LearningType?: string;
	AccessTypesString?: string;
	LearningFormats?: string[] | null;
	Location?: string;
	Cost?: string;
	CPDHours?: string;
	TypesOfResourcesString?: string;
	OpenAccessText: Field<string>;
	RCNiPlusSubscriberText: Field<string>;
	RCNMemberText: Field<string>;
	RegisteredUserText: Field<string>;
	OrganisationalProductText: Field<string>;
};

export function ContentDetailsHeader(props: contentDetailsHeaderProps): JSX.Element {
	const details = (Icon: JSX.Element, ContentDetail: string) => {
		if (!ContentDetail) {
			return;
		}

		return (
			<div className={ctaStyles.detail}>
				{Icon}
				<span>{ContentDetail}</span>
			</div>
		);
	};

	return (
		<div className={ctaStyles.column}>
			{(props.LearningType || props.AccessTypesString || props.LearningFormats) && (
				<div className={ctaStyles.firstHalf}>
					{props.LearningType && details(<BookSvg className={ctaStyles.icon} />, props.LearningType)}

					{props.AccessTypesString &&
						details(
							<PersonTickSvg className={ctaStyles.icon} />,
							getAccessTypeStringContent({
								accessType: props.AccessType,
								openAccessText: props.OpenAccessText,
								registeredUserText: props.RegisteredUserText,
								rcnMemberText: props.RCNMemberText,
								organisationalProductText: props.OrganisationalProductText,
								rcniPlusSubscriberText: props.RCNiPlusSubscriberText,
							}).text
						)}

					{props.LearningFormats && details(<PeopleSvg className={ctaStyles.icon} />, props.LearningFormats?.join(', '))}
				</div>
			)}
			{(props.Location || props.Cost || props.CPDHours || props.TypesOfResourcesString) && (
				<div className={ctaStyles.secondHalf}>
					{props.Location && details(<MarkerSvg className={ctaStyles.icon} />, props.Location)}

					{props.Cost && details(<PriceTagSvg className={ctaStyles.icon} />, props.Cost)}

					{props.CPDHours && details(<TimerSvg className={ctaStyles.icon} />, props.CPDHours)}

					{props.TypesOfResourcesString && details(<BookSvg className={ctaStyles.icon} />, props.TypesOfResourcesString)}
				</div>
			)}
		</div>
	);
}
